<template>
	<li
		class="menu_item__parent"
		:class="{ isActive: isActive }"
		@mouseover="show = true"
		@mouseleave="show = false"
	>
		<div class="parent_container">
			<a
				class="menu_item__parent__primary_link"
				:href="localUrlSwap(menu_item['url'])"
				v-html="menu_item['title']"
			></a>
			<div
				class="toggle-children"
				v-if="menu_item['children']"
				:class="{ is__active: isActive }"
				@click.stop="setActiveUid"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>
		</div>

		<transition name="fade">
			<div
				class="inner_menu_child"
				v-if="show && menu_item['children']"
			>
				<ul class="menu__child">
					<li
						class="menu_item__child"
						v-for="(sub_menu_item, index) in menu_item['children']"
						:key="index"
					>
						<a
							v-if="sub_menu_item"
							:href="localUrlSwap(sub_menu_item['url'])"
							v-html="sub_menu_item['title']"
						></a>
					</li>
				</ul>
			</div>
		</transition>
	</li>
</template>

<script>
let active = { uid: false };
addEventListener('click', () => (active.uid = false));

export default {
  data() {
    return {
      param: undefined,
      active: null,
      show: false,
    };
  },
  props: {
    menu_item: {},
  },
  computed: {
    isActive() {
      return this._uid == this.$store.state.active_uid;
    },
  },

  watch: {},

  methods: {
    localUrlSwap(value) {
      if (window.location.host === 'localhost:3000') {
        return value.replace('cpmec.test', 'localhost:3000');
      } else {
        return value;
      }
    },

    setActiveUid() {
      if (this.$store.state.active_uid === this._uid) {
        this.$store.state.active_uid = 0;
      } else {
        this.$store.commit('setActiveUid', this._uid);
      }
    },
  },

  components: {},

  created() {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.parent_container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;

  li {
    a {
      color: var(--white);
    }
  }
}

.inner_menu_child {
  .menu__child {
    padding: 5px 20px;
    margin-top: calc(var(--spacer) / 2);
    background-color: var(--cpmec-blue-dark);

    li {
      list-style-type: none;
      margin-bottom: 5px;
      text-align: center;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

li {
  text-align: center;

  a {
    color: $cpmec-green;
    text-decoration: none;
    font-weight: normal;
    font-size: 24px;
    transition: 0.2s ease all;
    width: 100%;

    &:hover {
      color: white;
      transition: 0.2s ease all;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  50% {
    transform: translateY(30px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.bounce-reverse-enter-active {
  animation: bounce-in-rev 0.5s;
}

.bounce-reverse-leave-active {
  animation: bounce-in-rev 0.5s reverse;
}

@keyframes bounce-in-rev {
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  50% {
    transform: translateY(-10px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fade-quick-enter-active {
  animation: fade-in-quick 0.5s;
}

.fade-quick-leave-active {
  animation: fade-in-quick 0.5s reverse;
}

@keyframes fade-in-quick {
  0% {
    transform: translateX(100vw);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuItemMob.vue